export const environment = {
  production: false,
  version: '1.0.0',
  environment: 'Desarrollo',
  productionEnvironmentName: 'Producción',
  systemId: 1,
  bovedaUrl: 'http://10.10.0.144:6070/api',
  jasper_server: 'jasperserver/rest_v2/reports/reports/',
  credencialesJasper: 'jasperadmin:jasperadmin',
  protocolo: 'ProtocoloEscanerConade:',

  // Gateway Services
  gatewayNotificacion: 'http://10.10.0.29:8082/',
  gatewayJasper: 'http://10.10.0.29:8080/',
  gatewaySiarURL: 'http://10.10.0.29:8084/',
  gatewayConfiguracionGlobalURL: 'https://globalconfig.conade.gob.mx/',
  gatewayOficialiaPartesURL: 'http://10.10.0.144:8021/',
  gatewayAutenticacionURL: 'https://boveda.conade.gob.mx/'
};
